import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { MyContext } from "../hooks/MyContextProvider";
import Loader from "../Component/Loader";

const NonAuthLayout = (props) => {
  const { token, loading } = useContext(MyContext);

  if (token) {
    return <Navigate to="/" replace />;
  }

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Outlet />
    </>
  );
};

export default NonAuthLayout;
